<template lang="pug">
#editor.columns
  .column
    b-input(
      type="textarea"
      rows="6"
      :value="input"
      @input="update"
    )
    small Use <a href="http://assemble.io/docs/Cheatsheet-Markdown.html" target="_blank">Markdown</a> to make this text awesome
  .column
    .content(v-html="compiledMarkdown")
</template>

<script>
import marked from 'marked';

export default {
  name: 'markdown-editor',
  computed: {
    compiledMarkdown() {
      if (!this.input) return '';
      return marked(this.input, { sanitize: true });
    },
  },
  data() {
    return {
      input: this.value,
    };
  },
  methods: {
    update(val) {
      this.input = val;
      this.$emit('input', val);
    },
  },
  props: [
    'value',
  ],
};
</script>

<style lang="scss">
#editor textarea {
  font-family: 'Monaco', courier, monospace;
}
</style>



// WEBPACK FOOTER //
// src/components/form/MarkdownEditor.vue